import { useNavigate, useSearchParams } from "react-router-dom";
import SC from "./style";
import theme from "@theme/";
import { formatFileSize } from "utils/helper";
import { Button } from "@InnoUI/";
import TimezoneConverter from "components/TimeZoneConvertor";
import { Checkbox } from "antd";
import { HighlightedText } from "@components/";
import ReadMoreText from "components/ReadMoreText";

const DocumentCard = (props) => {
  const { file, selectedItems, setSelectedItems, partialSearch } = props;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const type = searchParams.get("type");
  const searchKey = searchParams.get("searchKey");

  const handleFileClick = (data) => {
    navigate(
      `/document/file-details?projectId=${projectId}&fileId=${data.id}&parentId=${data.parentId}&folderId=${data.folderId}&type=${type}`
    );
  };

  const checkboxChange = (file, isChecked) => {
    const fileId = file.id;

    if (isChecked) {
      setSelectedItems((prev) =>
        prev.includes(fileId) ? prev : [...prev, fileId]
      );
    } else {
      setSelectedItems((prev) => prev.filter((id) => id !== fileId));
    }
  };

  return (
    <>
      <SC.Content key={file.id}>
        <SC.RowWrapper style={{ width: "100%" }}>
          <SC.ColumnMore>
            <Button
              caption={"View"}
              onClick={() => handleFileClick(file)}
              color="white"
              fontSize="12px"
              style={{
                background: "linear-gradient(135deg, #E36E00 0%, #FFAE00 100%)",
                color: theme.colors.white,
                minWidth: "40px",
                height: "22px",
                borderRadius: theme.modernTokens.borderRadius.md,
                textTransform: "normal",
                fontWeight: 500,
                border: "none",
                boxShadow: theme.modernTokens.shadows.sm,
                transition: theme.modernTokens.transitions.normal,
              }}
            />
          </SC.ColumnMore>
          <SC.ColumnDescription>
            <SC.FolderHierachy>
              <HighlightedText
                text={file?.folderHierachy}
                searchText={searchKey}
                partialSearch={partialSearch}
              />
            </SC.FolderHierachy>
            <SC.ChildContainer>
              <SC.Span>
                <HighlightedText
                  text={file?.subject}
                  searchText={searchKey}
                  partialSearch={partialSearch}
                />
              </SC.Span>{" "}
              -{" "}
              <SC.FileName>
                <HighlightedText
                  text={file?.fileName}
                  searchText={searchKey}
                  partialSearch={partialSearch}
                />
              </SC.FileName>
            </SC.ChildContainer>
            <SC.Note>
              <ReadMoreText
                text={file?.note}
                searchText={searchKey}
                maxChars={200}
                partialSearch={partialSearch}
              />

              {/* <HighlightedText text={file?.note} searchText={searchKey} /> */}
            </SC.Note>
          </SC.ColumnDescription>
          <SC.ColumnSize>{formatFileSize(file?.fileSize)}</SC.ColumnSize>
          <SC.ColumnDate>
            <TimezoneConverter time={file.createdOn} />
          </SC.ColumnDate>
          <SC.ColumnCart>
            <Checkbox
              checked={selectedItems.includes(file.id)}
              onChange={(e) => checkboxChange(file, e.target.checked)}
            />
          </SC.ColumnCart>
        </SC.RowWrapper>
      </SC.Content>
    </>
  );
};

export default DocumentCard;
